import { createActionsRest } from '../../../dashboardCommon/utils/wlsGetActions';
import Continue from '../continue';
import CancelOrder from '../cancelOrder';
import View from '../view';
import Locked from '../lockedOrder';

export const actionsRest = createActionsRest({
  INCOMPLETE: [Continue, CancelOrder],
  ORDER_VALIDATED: [Locked],
  PENDING_VALIDATION: [View],
  WAITING_ON_SALES: [View, Continue],
  ORDER_CANCELED: [View, Continue],
  CANCELED_BY_SALESREP: [View, Continue]
});
